import useAuthImage from '../helpers/useAuthImage'

const AuthImage = ({ src, ...props }) => {
  const imgSrc = useAuthImage(src)
  return <img src={imgSrc || src} {...props} />
}

export default AuthImage